import Image from 'next/image';
import {VillageMedia} from '@/services/types';
import getMediaFilterUrl from '@/utils/get-media-filter';

type Props = {
  handleOpenModal: () => void;
  villageMedia: VillageMedia[];
};

export default function VideoModalTrigger({
  handleOpenModal,
  villageMedia,
}: Props) {
  const videoMedia = villageMedia.filter((file) => file.type === 'video')[0];
  const villageVideoCover = `${videoMedia?.path}${videoMedia?.filename}`;

  const filteredVideoCover = getMediaFilterUrl({
    mediaFilters: videoMedia?.mediaFilters,
    filterName: 'large_3-2_webp',
  });

  return (
    <div
      onClick={handleOpenModal}
      className="h-[50%] w-full flex-[0_0_auto] cursor-pointer">
      <div className="h-[calc(30vh-15px)] min-h-[260px] relative max-h-[900px]">
        <Image
          src={
            filteredVideoCover ??
            `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/large_3-2_webp/${villageVideoCover}`
          }
          alt="play video"
          width={100}
          height={100}
          className="opacity-100 transition-all duration-300 ease-in-out w-full h-full object-cover object-[50%_50%] inline-block align-middle max-w-full"
          sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
        />
        <div className="bg-[rgba(0,0,0,.2)] absolute top-0 left-0 w-full h-full p-[30px] flex flex-col items-center justify-center text-white">
          <div className="cursor-pointer w-[80px] h-[80px] flex items-center justify-center">
            <Image
              width={80}
              height={80}
              src="https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/play.png"
              alt="View all"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

{
  /* {isOpen && (
        <div
          role="dialog"
          className="fixed right-0 bottom-0 w-full h-full min-h-full bg-black z-50 overflow-y-auto p-4">
          <div className="h-full flex flex-col">
            <div className="m-auto h-[calc(100%-120px)] w-[90%]">
              <iframe
                className="h-full w-full"
                frameBorder="0"
                allowFullScreen
                src={`https://www.youtube.com/embed/${videoUrl}`}
              />
            </div>
          </div>
          <button
            onClick={handleCloseModal}
            className="absolute top-4 right-4 z-50 cursor-pointer appearance-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 fill-current text-white"
              viewBox="0 -960 960 960">
              <path d="m256-168-88-88 224-224-224-224 88-88 224 224 224-224 88 88-224 224 224 224-88 88-224-224-224 224Z" />
            </svg>
          </button>
        </div>
      )} */
}
